import React from 'react';

const AssortmentsProfessionalSimpleIllustrationSvg = (props) => (
    <svg viewBox="0 0 176 176" {...props}>
        <path
            d="M38 35.57a4.82 4.82 0 0 0 .13 1.61l14.28 56 1.82.21 1.55-1-11.46-56.62a4.82 4.82 0 0 0-.58-1.51l-4.88-8.2zM83.48 32.25c0-1.78-2-3.87-2-7.82 0-8.61 18.86-10.35 18.86 3.2 0 10.65-11.78 13.33-3.27 17.91a.5.5 0 0 1-.27.94c-3.52-.25-9.7-1.44-9.7-6.69 0-7.34 4.39-8.27 4.39-11.64s-6.39-4.89-6.39 4.3z"
            fill="#f6682f"
        />
        <path
            d="M84.61 156.86l.19-64.07-13 6.73c-.38 8.34 4.5 56.28 4.5 56.28l2.39 3.64z"
            fill="#c3c6cf"
        />
        <path
            d="M78.14 158.58l-1.82-2.77a27.72 27.72 0 0 1-6.88 4.4 12.9 12.9 0 0 0-3.25 2.7h18.42v-6l-5 2.17a1.23 1.23 0 0 1-1.47-.5z"
            fill="#62666d"
        />
        <path
            d="M101.36 156.34a8.29 8.29 0 0 1-1.36-3.22c-1.1-5.37-1.72-58.59-1.72-58.59H83.72l9.15 62.16 4.33 2.76z"
            fill="#c3c6cf"
        />
        <path
            d="M110.79 162.9c-1.64-2.81-6.79-2.86-9.43-6.56L98 158.85a1.45 1.45 0 0 1-1.65.06l-3.49-2.23L94 162.9z"
            fill="#62666d"
        />
        <path
            d="M72.91 67.39c-4 14.49-16.33 33.13-16.33 33.13l-1.68-5.26s7.81-18.77 8.77-27.87z"
            fill="#c3c6cf"
        />
        <path
            d="M54.23 92.67l-8.58 2.2c2.13 3.41 9.24.4 9.24.4s8.3-1.93 7.91-4.8z"
            fill="#6d717a"
        />
        <path
            d="M53.211 94.31l2.838-.728 2.29 8.921a1 1 0 0 1-.721 1.218l-.9.23a1 1 0 0 1-1.218-.72l-2.289-8.92z"
            fill="#6d717a"
        />
        <path
            d="M83.61 98.9l-2.53 7.91H69s1.45-12.56 6.44-22.63h18.6s4 13.61 6.52 22.63H84.8z"
            fill="#62666d"
        />
        <path fill="#282c35" d="M75.46 81.12h18.5v3.07h-18.5z" />
        <path
            d="M84.8 57H70.09c2.78 9.4 5.37 24.16 5.37 24.16h18.69S96.73 66.35 99.51 57z"
            fill="#c3c6cf"
        />
        <path
            d="M70.09 57c-5.6 0-7.37 7.06-7.82 9.57a.74.74 0 0 0 .73.87h9.9l4.28-4.69z"
            fill="#282c35"
        />
        <path
            d="M90 52.49H79.24c-.71 2.84-7 4.47-9.15 4.47l13.69 15.81a1.11 1.11 0 0 0 1.67 0L99.14 57C97 57 90.7 55.33 90 52.49z"
            fill="#62666d"
        />
        <path
            d="M73.8 129.42h7.13L82 158l-2.54 1.12a1 1 0 0 1-1.23-.36l-1.93-2.94s-1.16-10.26-2.5-26.4z"
            fill="#282c35"
        />
        <path
            fill="#c3c6cf"
            d="M87.59 31.04H81.64l-4.67 8.49 2.13 13.22h11.04l2.13-13.22-4.68-8.49z"
        />
        <path
            d="M89.87 41.11H79.36a1.5 1.5 0 0 1 0-3h10.51a1.5 1.5 0 0 1 0 3z"
            fill="#282c35"
        />
        <path
            d="M68 80.1s-1.27 2.57-1.81 3.6l-6.94.48-.3-2.6a3.41 3.41 0 0 1 .92-2.75l1.6-1.68z"
            fill="#62666d"
        />
        <path
            d="M96.41 93l5.59-1.7s9.09 38.53 6.9 38.53C106.91 129.82 96.41 93 96.41 93z"
            fill="#282c35"
        />
        <path d="M54.4 102l-2-5.9 5-1.54s.81 6.18-3 7.44z" fill="#d2d6df" />
        <path
            d="M90.56 57.35s-5.15 33.17 8.63 47.45C118 98.53 128.8 66.74 128.8 66.74c-8.89-10.17-27.44-13.02-38.24-9.39z"
            fill="#f6682f"
        />
        <circle
            cx={107.21}
            cy={72.2}
            r={6.5}
            transform="rotate(-31.22 107.204 72.184)"
            fill="#ffa71a"
        />
        <path
            d="M85.22 35H84l-1.76 4.66 2.21 9.82a.16.16 0 0 0 .32 0L87 39.61z"
            fill="#6d717a"
        />
        <path
            d="M127 163.9H43.34a1 1 0 0 1 0-2H127a1 1 0 0 1 0 2zM99.69 157.59l-6.2-28.17h6.43l1.44 26.92-1.67 1.25z"
            fill="#282c35"
        />
    </svg>
);

AssortmentsProfessionalSimpleIllustrationSvg.displayName =
    'AssortmentsProfessionalSimpleIllustrationSvg';
export default AssortmentsProfessionalSimpleIllustrationSvg;
